export const getRelativeTime = (publishedAt, now, isCompact = false) => {
    const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
    const publishedDate = new Date(publishedAt);

    if (isNaN(publishedDate.getTime())) {
        console.error("Invalid date format:", publishedAt);
        return "Invalid date";
    }

    const seconds = Math.floor((now.value - publishedDate) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) {
        return "now";
    } else if (minutes < 60) {
        return `${minutes}m`;
    } else if (hours < 24) {
        return `${hours}h`;
    } else if (days < 30) {
        return isCompact ? `${days}d` : rtf.format(-days, "day");
    } else if (months < 12) {
        return isCompact ? `${months}mo` : rtf.format(-months, "month");
    } else {
        return isCompact ? `${years}y` : rtf.format(-years, "year");
    }
};
